import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";

import { useQuery } from "@tanstack/react-query";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";
import { useFetchDetailsApiArguments } from "./useFetchDetailsApiArguments";

// The server caps GetDetails at 60 seconds (FeeAndAdjustmentController.DetailsRequestTimeout). This
// client limit sits just above it so a hung connection still errors out and triggers the
// Report Queue fallback rather than leaving the user waiting.
const CLIENT_REQUEST_TIMEOUT_MS = 75 * 1000;

export function useFetchExportDetailsData(
  email,
  submittedFormData,
  selectedFeeCodes,
  exportIsRunning = false //this will only be enabled when the export is running - such as during an export scenario when the export is not running
) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useFetchExportDetailsDataResultKey";

  const { apiUrl: url, apiParams } = useFetchDetailsApiArguments(
    email,
    submittedFormData,
    selectedFeeCodes
  );

  async function GetDetailsData() {
    const accessToken = oktaAuth.getAccessToken();

    var result = await axios
      .get(url, {
        params: apiParams,
        timeout: CLIENT_REQUEST_TIMEOUT_MS,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });

    return result;
  }

  function IsEnabled() {
    if (IsNullOrEmpty(apiParams)) return false;

    return exportIsRunning;
  }

  return useQuery({
    queryKey: [dataKey, url, apiParams],
    queryFn: async () => await GetDetailsData(),
    enabled: IsEnabled,
    retry:false
  });
}
